<template>
    <!--顾客来源-->
    <el-select  :value="value" :value-key="type=='object'?'id':''" :size="size" @visible-change="visiblechange" :placeholder="placeholder" @change="change">
        <el-option
                v-for="item in list"
                :key="item.id"
                :label="item.customFrom"
                :value="type=='object'?item:item.id">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "user-from",
        props: {
            size: String,
            placeholder: String,
            value:Object|String,
            type:String//是对象还是字符串
        },
        model: {
            prop: 'value',
            event: 'input'
        },
        data() {
            return {
                list: [],
                choosevalue:''
            }
        },
        watch:{
            value(newval,oldval){
                var code=this.type=='object'?newval.id:newval;
                var list=this.list.filter((item)=>item.id==code);
                //数据不存在时
                if(list.length==0){
                    this.getData();
                }

            }
        },
        mounted(){
            this.getData();
        },
        methods: {
            getData(){
                this.$axios.get('/customFrom/findByStoreId/'+this.$root.getStorage('storeId')).then(res => {
                    console.log(res)
                    this.list = res.data.list;
                    // var list = this.list.filter((item) => item.id == this.value);
                    // if(list.length>0){
                    //     this.changeData(list[0]);
                    // }
                }).catch(err => {
                    console.log(err)
                })
                // if(this.$root.getStorage('dic')){
                //     this.list=this.$root.getStorage('dic').filter((item)=>item.dicType=='user_from');
                // }else{
                //     this.$store.state.dicChange=true;
                // }
            },
            visiblechange(isshow) {
                if (isshow) {
                    // this.getData();
                }
            },
            change(value) {
                console.log(value)
                this.$emit('input', value)
            }
        }
    }
</script>

<style scoped>

</style>